import { createFileRoute } from "@tanstack/react-router"
import { DeleteOutlookIntegration } from "modules/settings/components/integrations/outlook/DeleteOutlookIntegration"

export const Route = createFileRoute(
  "/_base/_auth/settings/channels/outlook/deleteIntegration/$id",
)({
  component: DeleteOutlookIntegration,
})
